import { Dialog, DialogContent, DialogTitle, DialogDescription } from "../ui/dialog";
import { motion } from "framer-motion";
import { Check, Phone } from "lucide-react";
import { PHONE, TEL, TIME_WINDOWS } from "../../lib/data";

export const BookingSuccess = ({ booking, onClose }) => {
  const win = TIME_WINDOWS.find((t) => t.value === booking?.time_window)?.label ?? "";
  return (
    <Dialog open={!!booking} onOpenChange={(o) => !o && onClose()}>
      <DialogContent data-testid="booking-confirmation-modal" className="max-w-md rounded-3xl border-white/10 bg-[#0d0d15] p-8 text-white">
        <motion.div initial={{ scale: 0, rotate: -90 }} animate={{ scale: 1, rotate: 0 }} transition={{ type: "spring", stiffness: 220, damping: 14 }} className="flex h-16 w-16 items-center justify-center rounded-2xl bg-neon">
          <Check className="h-8 w-8" />
        </motion.div>
        <DialogTitle className="font-race mt-4 text-5xl leading-none">Request received!</DialogTitle>
        <DialogDescription className="text-base text-zinc-300">
          Thanks, {booking?.name}. We'll call you at <span data-testid="confirmation-phone" className="font-semibold text-white">{booking?.phone}</span> to confirm your appointment.
        </DialogDescription>
        <div className="space-y-2 rounded-2xl border border-white/10 bg-black/40 p-5 text-sm text-zinc-300">
          <div><span className="text-zinc-400">Vehicle: </span>{booking?.vehicle_year} {booking?.vehicle_make} {booking?.vehicle_model}</div>
          <div><span className="text-zinc-400">Requested: </span>{booking?.preferred_date} · {win}</div>
          <div><span className="text-zinc-400">Service: </span>{(booking?.services ?? []).join(", ")}</div>
        </div>
        <p className="text-sm text-zinc-400">Expect a call from {PHONE}. Need us sooner?</p>
        <a href={TEL} data-testid="confirmation-call-button" className="btn-neon flex items-center justify-center gap-2 rounded-full py-4 text-sm font-bold uppercase tracking-wider">
          <Phone className="h-4 w-4" /> Call {PHONE}
        </a>
      </DialogContent>
    </Dialog>
  );
};
